goog.provide("shadow.js.shim.module$$mui$material$AppBar$default");
shadow.js.shim.module$$mui$material$AppBar$default = shadow.js.shim.module$$mui$material$AppBar.default;
